{
  "global": {
    "backToHome": "Back to homepage",
    "errors": {
      "unhandledError": "An unhandled error has occurred",
      "serverError": "An error has occurred. Please retry later.",
      "accessDenied": "Access denied",
      "attachmentTooBig": "Your file is too big. Please retry with a smaller document."
    }
  },
  "header": {
    "logoAlt": "CIM Bank - Swiss private bank",
    "btnLogout": "Logout",
    "btnMessages": "Messages",
    "btnRegistrations": "My registrations"
  },
  "footer": {
    "copyright": "© CIM Banque SA - Geneva, Lugano, Wollerau - Switzerland",
    "contactFormLabel": "Contact form",
    "contactFormSubtitle": "Please kindly use our contact form to get in touch with one of our specialists. We will be glad to help you!",
    "relationshipManagerLabel": "My Relationship Manager",
    "contactHours": "Monday to Friday, 08:30 AM to 06:30 PM",
    "contactPhone": "+41 (0)58 225 50 50"
  },
  "modal": {
    "confirmButton": "Ok",
    "cancelButton": "Cancel",
    "remark": "Remark"
  },
  "attachment": {
    "fileNoName": "Unnamed file",
    "errors": {
      "noMultipleFilesAllowed": "Only one file can be uploaded at a time",
      "allowedTypes": "Only images or PDF are allowed",
      "unhandledError": "An error has occurred while uploading the file. Please check size (max 8MB)."
    }
  },
  "gender": {
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "genderError": "Gender is mandatory"
  },
  "maritalStatusEnum": {
    "single": "Single",
    "married": "Married",
    "divorced": "Divorced",
    "widower": "Widowed",
    "civilUnion": "Civil Union"
  },
  "counterpartyOperationTypeEnum": {
    "import": "Import",
    "export": "Export",
    "intermediation": "Intermediation",
    "fees": "Fees",
    "logisticsAndTransport": "Logistics & transport",
    "administrativePayments": "Administrative payments",
    "dividens": "Dividends",
    "other": "Other"
  },
  "counterpartyCashFlowTypeEnum": {
    "incoming": "Incoming",
    "outgoing": "Outgoing"
  },
  "signatureTypeEnum": {
    "signature": "Signature",
    "signatureIndividual": "Individual",
    "signatureCollective": "Collective",
    "none": "No"
  },
  "validation": {
    "onlyChars": "This field must contains only chars or digits"
  },
  "messages": {
    "messagesDialogTitle": "Messages",
    "messageBy": "By {username}",
    "messageOn": "on {date}",
    "messageSeen": "Seen by {username} on {date}",
    "addMessage": "Type a message...",
    "addAttachment": "Add attachment",
    "submit": "Submit"
  },
  "login": {
    "email": "E-mail",
    "btnRequestAccess": "Get secured link",
    "openAccount": "Open an account?",
    "description": "We will send you an e-mail with a link that will provide you a secured access to our platform.",
    "successMessage": "Please check your e-mails and connect using the secure link.",
    "errors": {
      "invalidToken": "The link is not valid. Please type your e-mail address and we will send you an e-mail with a link that will provide you a secured access to our platform.",
      "genericError": "An error has occurred. Please retry later.",
      "email": "E-mail is required",
      "emailInvalid": "E-mail must be valid",
      "noRecipientFound": "This e-mail has not been found"
    }
  },
  "open": {
    "btnBack": "Back",
    "btnNext": "Next",
    "btnSubmit": "Submit",
    "invitationOnly": "Invitation only",
    "invitationOnlyMessage": "Dear customer,<br/>Our on-boarding platform is restricted to invited persons.<br/>To apply, please contact one of our relationship manager using the <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/en/the-bank/contact-us/\">contact form</a>.",
    "yes": "Yes",
    "no": "No",
    "tabs": {
      "accountType": "Account type",
      "individual": {
        "contactInformation": "Personal & contact",
        "additionalInformation": "Additional information",
        "confirmation": "Confirmation"
      },
      "company": {
        "companyInformation": "Your company",
        "contactInformation": "Personal information",
        "additionalInformation": "Additional information",
        "confirmation": "Confirmation"
      }
    },
    "accountType": {
      "title": "Choose your account type",
      "subtitle": "Let's get started! Please, select what type of account would you like to open.",
      "optionIndividual": "Personal account",
      "optionIndividualInformation": "Opening fees of <span class=\"cim-pink\">90</span> CHF/EUR/USD",
      "optionCorporate": "Corporate account",
      "optionCorporateInformation": "Opening fees of <span class=\"cim-pink\">500</span> CHF/EUR/USD",
      "warningPotential": ""
    },
    "individual": {
      "contactInformation": {
        "title": "Fill your personal & contact details",
        "firstName": "First name",
        "middleName": "Middle name",
        "lastName": "Last name",
        "email": "E-mail",
        "repeatEmail": "Repeat e-mail",
        "mobilePhone": "Mobile phone",
        "repeatMobilePhone": "Repeat mobile phone"
      },
      "additionalInformation": {
        "title": "Fill additional information",
        "birthDate": "Date of birth",
        "cityOfBirth": "City of birth",
        "countryOfBirth": "Country of birth",
        "countryOfResidence": "Country of residence",
        "nationality": "Nationality",
        "preferredLanguage": "Preferred language"
      },
      "confirmation": {
        "greetings": "Thank you!",
        "messageInvited": "We have sent you an e-mail with further instructions to complete your account opening request. Please follow the link in the e-mail to connect to MyCIM. If you don't have it, check your spam box.",
        "message": "A relationship manager will contact you soon and begin the procedure of account opening."
      },
      "errors": {
        "firstName": "First name is mandatory",
        "lastName": "Last name is mandatory",
        "email": "E-mail is mandatory",
        "emailInvalid": "E-mail must be valid",
        "emailsDifferent": "E-mails must match",
        "mobilePhone": "Mobile phone is mandatory and must be valid (i.e. +41XXXXXXXXX)",
        "mobilePhonesDifferent": "Mobile phones must match",
        "birthDate": "Date of birth is mandatory and must be valid",
        "birthDateFuture": "Date of birth can't be later than today",
        "cityOfBirth": "City of birth is mandatory",
        "countryOfBirth": "Country of birth is mandatory",
        "countryOfResidence": "City of residence is mandatory",
        "nationality": "Nationality is mandatory",
        "preferredLanguage": "Preferred language is mandatory"
      }
    },
    "company": {
      "companyType": {
        "domiciliaryTitle": "Non-Operating company",
        "domiciliarySubtitle": "Holding participations or assets.",
        "operatingTitle": "Operating company",
        "operatingSubtitle": "Provision of services or conducting trade.",
        "otherTitle": "Other",
        "otherSubtitle": "Trust, foundation or association, insurance wrapper."
      },
      "roleInCompany": {
        "noRole": "No formal role in the structure",
        "beneficial": "Beneficial Owner",
        "shareholder": "Shareholder",
        "signatory": "Signatory",
        "introducingPartner": "Introducing Partner",
        "director": "Director"
      },
      "companyInformation": {
        "title": "Select your company type",
        "companyName": "Company name",
        "companyTypeRemark": "Non-operating company justification",
        "incorporationCountry": "Incorporation country",
        "contactTheBank": "Please contact the bank to continue your opening procedure"
      },
      "contactInformation": {
        "title": "Fill your own personal details",
        "info": "Please provide your contact information with which we can get back to you",
        "firstName": "First name",
        "lastName": "Last name",
        "role": "What is your role in the company?",
        "cimBanqueCustomer": "Are you a CIM Banque customer?",
        "accountNumber": "What is your account number?",
        "howHeard": "How have you heard of CIM Banque?"
      },
      "additionalInformation": {
        "title": "Fill your own contact details",
        "email": "E-mail",
        "repeatEmail": "Repeat e-mail",
        "mobilePhone": "Mobile phone",
        "repeatMobilePhone": "Repeat mobile phone",
        "preferredLanguage": "Preferred language"
      },
      "confirmation": {
        "greetings": "Thank you!",
        "messageInvited": "We have sent you an e-mail with further instructions to complete your account opening request. Please follow the link in the e-mail to connect to MyCIM. If you don't have it, check your spam box.",
        "message": "A relationship manager will contact you soon and begin the procedure of account opening."
      },
      "errors": {
        "companyName": "Company name is mandatory",
        "incorporationCountry": "Incorporation country is mandatory",
        "role": "Role is mandatory",
        "alreadyCustomer": "This field is mandatory",
        "accountNumber": "Account number is mandatory",
        "firstName": "First name is mandatory",
        "lastName": "Last name is mandatory",
        "email": "E-mail is mandatory",
        "emailInvalid": "E-mail must be valid",
        "emailsDifferent": "E-mails must match",
        "mobilePhone": "Mobile phone is mandatory and must be valid (i.e. +41XXXXXXXXX)",
        "mobilePhonesDifferent": "Mobile phones must match",
        "preferredLanguage": "Preferred language is mandatory",
        "companyTypeRemark": "The justification is mandatory"
      }
    }
  },
  "register": {
    "btnBack": "Back",
    "btnPrevious": "Previous",
    "btnCancel": "Cancel",
    "btnNext": "Next",
    "btnContinue": "Continue",
    "btnSubmit": "Submit",
    "btnSave": "Save",
    "yes": "Yes",
    "no": "No",
    "tabs": {
      "individualAccountUsage": "Purpose of the account",
      "individualInformation": "Personal information",
      "familyAndJob": "Family and Job",
      "contract": "Contract",
      "yourDocuments": "Your documents",
      "companyAccountUsage": "Purpose of the account",
      "companyInformation": "Company information",
      "companyStructure": "Structure of the company",
      "companyTransaction": "Transaction information",
      "companyCounterparties": "Counterparties",
      "underReview": "Under review",
      "refused": "Refused",
      "initialDeposit": "Initial deposit"
    },
    "prospectSelection": {
      "title": "MyCIM pending registrations",
      "continue": "Continue",
      "openAnotherAccount": "Open another account"
    },
    "individualAccountUsage": {
      "title": "Pick the purpose of the account for {displayName}",
      "accountUsages": {
        "savingsAndInvestments": "Savings & Investments",
        "currentAccount": "Current account",
        "other": "Other, specify"
      }
    },
    "companyAccountUsage": {
      "title": "Pick the purpose of the account for {displayName}",
      "accountUsages": {
        "commercialActivity": "Commercial activity",
        "savingsAndInvestments": "Savings & Investments",
        "currentAccount": "Current account",
        "other": "Other, specify"
      }
    },
    "individualInformation": {
      "title": "Fill the personal details of the account for {displayName}",
      "subtitle": "Dear {username}, we need you to answer the following questions",
      "addressLine1": "Address",
      "zipCode": "Zip code",
      "city": "City",
      "residenceCountryIsoCode": "Country of residence",
      "passportNumber": "Passport number",
      "passportExpirationDate": "Passport expiration date",
      "taxationCountryIsoCode": "Taxation country",
      "tinNumber": "TIN number",
      "hasTinNumber": "I don't have a TIN number",
      "relationWithUSA": "Relationship with the USA",
      "isLinkedToUnitedStates": "Are you an US person?",
      "hasUSPassportOrGreenCard": "Do you have USA passport or a Green card?",
      "hasSpentSubstantialTimeInUS": "Have you ever stayed for more than 90 days in the US?",
      "isUSResidentForAnyOtherReason": "Do you own real estate in the USA?",
      "errors": {
        "addressLine1": "Address is mandatory",
        "zipCode": "Zip code is mandatory",
        "city": "City is mandatory",
        "passportNumber": "Passeport number is mandatory",
        "passportExpirationDate": "Passport expiration date is mandatory and must be valid",
        "passportExpirationDateOutdated": "The date must be greater than today's date",
        "residenceCountryIsoCode": "Country is mandatory",
        "taxationCountryIsoCode": "Taxation country is mandatory",
        "tinNumber": "TIN number is mandatory",
        "isLinkedToUnitedStates": "USA Related field is mandatory",
        "hasUSPassportOrGreenCard": "Please select a value",
        "hasSpentSubstantialTimeInUS": "Please select a value",
        "isUSResidentForAnyOtherReason": "Please select a value"
      }
    },
    "individualFamily": {
      "family": "Family for {displayName}",
      "maritalStatus": "Marital status",
      "spouse": "Spouse / Partner",
      "needJointAccount": "I need a joint account",
      "children": "Children",
      "addChild": "Add child",
      "job": "Job for {displayName}",
      "roleLabel": "Job / Occupation 1/2",
      "jobLabel": "Job / Occupation 2/2",
      "workplaceCountry": "Workplace country",
      "firstName": "First name",
      "lastName": "Last name (Maiden name)",
      "errors": {
        "maritalStatus": "Marital status is required",
        "job": "Activity is required",
        "workplaceCountryIsoCode": "Workplace location is required",
        "partnerFirstName": "First name is required",
        "partnerLastName": "Last name is required"
      }
    },
    "individualInProgressModal": {
      "title": "Thank you for your information",
      "subtitle": "Your data has been successfully saved",
      "message": "Please make sure that all your personal details are correct before continuing as you won't be able to change them once on the next step"
    },
    "individualContract": {
      "title": "Contract, terms & conditions",
      "subtitle": "Dear {username}, you are about to sign your contract. Please take some time too read it.",
      "openAndRead": "Open and read the draft version of my agreement",
      "contractAgreement": "I have read and I agree with my contract",
      "termsAgreement": "I have read and I agree with my CIM Banque's <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/06_general-terms-and-conditions-en.pdf\">terms & conditions</a>",
      "feesAgreement": "I have read and I agree with my CIM Banque's <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fees-for-private-accounts\">fees & commissions</a>",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "I have read and I agree with <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/special_risks_security_trading.pdf\">risks involved in trading financial instruments</a>",
      "errors": {
        "contractAgreement": "This field is mandatory",
        "termsAgreement": "This field is mandatory",
        "feesAgreement": "This field is mandatory",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "This field is mandatory"
      }
    },
    "individualDocuments": {
      "title": "Upload documents for {displayName}",
      "certificateOfResidence": "Certificate of Residence",
      "certificateOfResidenceSubtitle": "Drag and drop or click to upload the <span class='document-subtitle-string'>Certificate of Residence*</span> for this holder",
      "passport": "Passport",
      "passportSubtitle": "Drag and drop or click to upload the <span class='document-subtitle-string'>Passport</span> for this holder",
      "datedLess": "* Dated less than 12 months and issued by a competent government authority - Please note utility bills and bank statements are no longer accepted",
      "errors": {
        "allowedTypes": "Only images or PDF are allowed",
        "unhandledError": "An error has occurred while uploading the file. Please check size (max 8MB)."
      }
    },
    "companyInformation": {
      "title": "Fill your company information for {displayName}",
      "addressLine1": "Address",
      "addressLine2": "Complementary address",
      "zipCode": "Zip code",
      "city": "City",
      "residenceCountryIsoCode": "Country",
      "website": "Website",
      "shareCapital": "Share capital",
      "shareCapitalCurrencyIsoCode": "Currency",
      "dateOfIncorporation": "Date of incorporation",
      "countryOfIncorporation": "Country of incorporation",
      "roleLabel": "Activity 1/2",
      "activityId": "Activity 2/2",
      "activityRemark": "Activity description",
      "hasBalanceSheetFinancialStatement": "The company has an audited balance sheet?",
      "hasExternalAccounting": "The company has an external accounting?",
      "hasPhysicalOffice": "The company has physical offices in {countryName}?",
      "officeCountryIsoCode": "Country of offices",
      "numberOfEmployees": "Number of employees in offices",
      "hasEmployeesInPlaceOfIncorporation": "The company has employees in {countryName}?",
      "hasDirectorInPlaceOfIncorporation": "The company has a director in {countryName}?",
      "holdAnOperatingCompany": "The company holds an active operating company?",
      "hasReadAndAgreeWithTermsAndConditions": "I have read and I agree with my CIM Banque's <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/2021_mycim_general-terms-and-conditions-en.pdf\">terms & conditions</a>",
      "hasReadAndAgreeWithFeesAndCommissions": "I have read and I agree with my CIM Banque's <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fees-for-company-accounts\">fees & commissions</a>",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "I have read and I agree with <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/docs/default-source/pdf/special_risks_security_trading.pdf\">risks involved in trading financial instruments</a>",
      "errors": {
        "addressLine1": "Address is mandatory",
        "zipCode": "Zip code is mandatory",
        "city": "City is mandatory",
        "residenceCountryIsoCode": "Country is mandatory",
        "shareCapital": "Share capital is mandatory",
        "shareCapitalCurrencyIsoCode": "Currency is mandatory",
        "dateOfIncorporation": "Date of incorporation is mandatory and must be valid",
        "pastDateOfIncorporation": "Date of incorporation must be before today",
        "countryOfIncorporation": "Country of incorporation is mandatory",
        "officeCountryIsoCode": "Country of offices is mandatory",
        "numberOfEmployees": "Number of employees is mandatory",
        "activityId": "Activity is mandatory",
        "activityRemark": "Activity description is mandatory if activity is Other",
        "hasBalanceSheetFinancialStatement": "This field is mandatory",
        "hasExternalAccounting": "This field is mandatory",
        "hasPhysicalOffice": "This field is mandatory",
        "hasEmployeesInPlaceOfIncorporation": "This field is mandatory",
        "hasDirectorInPlaceOfIncorporation": "This field is mandatory",
        "hasReadAndAgreeWithTermsAndConditions": "This statement is mandatory",
        "hasReadAndAgreeWithFeesAndCommissions": "This statement is mandatory",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "This statement is mandatory",
        "holdAnOperatingCompany": "This field is mandatory"
      }
    },
    "companyStructure": {
      "signatory": "Signatory",
      "ubo": "UBO",
      "ownershipTotalTitle": "Total ownership",
      "ownershipTotalWarning": "Sum of ownership should be equals to 100%",
      "ownershipTitle": "Ownership",
      "noUBO": "No UBO added",
      "noSignatories": "No signatories added",
      "addNewEntity": "Add UBO or Signatory",
      "incompleteRelatedEntites": "At least one UBO or signatory is incomplete",
      "title": {
        "companyStructure": "Describe the structure of the company",
        "relativeEntitySelection": "People involved in the company",
        "relativeEntityBeneficialOwnerAdd": "Add an ultimate beneficial owner (UBO) for {displayName}",
        "relativeEntityBeneficialOwnerEdit": "Edit an ultimate beneficial owner (UBO) for {displayName}",
        "relativeEntitySignatoryAdd": "Add a signatory for {displayName}",
        "relativeEntitySignatoryEdit": "Edit a signatory for {displayName}",
        "relativeEntityPowerOfAttorneyAdd": "Add a signatory for {displayName}",
        "relativeEntityPowerOfAttorneyEdit": "Edit a signatory for {displayName}"
      },
      "deleteModal": {
        "UBOTitle": "Are you sure to delete this UBO?",
        "UBOSubtitle": "You are about to delete this UBO: {entityName}",
        "signatoryTitle": "Are you sure to delete this signatory?",
        "signatorySubtitle": "You are about to delete this signatory: {entityName}"
      }
    },
    "companyRelativeEntitySelection": {
      "addUbo": "Add an UBO",
      "addUboInformation": "Add an ultimate beneficial owner (UBO)",
      "addSignatory": "Add a signatory",
      "addSignatoryInformation": "Add a signatory (Power of attorney)"
    },
    "companyRelativeEntity": {
      "ownership": "Ownership",
      "percentageOfOwnership": "Percentage of ownership",
      "personalInformation": "Personal information",
      "firstName": "First name",
      "middleName": "Middle name",
      "lastName": "Last name",
      "nationalityIsoCode": "Nationality",
      "birthDate": "Date of birth",
      "cityOfBirth": "City of birth",
      "countryOfBirthIsoCode": "Country of birth",
      "contactInformation": "Contact information",
      "addressLine1": "Address",
      "addressLine2": "Complementary address",
      "zipCode": "Zip code",
      "city": "City",
      "residenceCountryIsoCode": "Country of residence",
      "mobilePhoneNumber": "Phone number",
      "email": "Email",
      "passportInformation": "Passport information",
      "passportNumber": "Passport number",
      "passportExpirationDate": "Passport expiry date",
      "jobInformation": "Activity",
      "role": "Job information 1/2",
      "activityId": "Job information 2/2",
      "workplaceCountryIsoCode": "Country of workplace",
      "isPoliticallyExposed": "Is the UBO politically exposed?",
      "isDirector": "Is the director within company's structure?",
      "taxationInformation": "Taxation information",
      "taxationCountryIsoCode": "Taxation country",
      "tinNumber": "TIN Number",
      "hasTinNumber": "I don't have a TIN number",
      "isLinkedToUnitedStates": "Has the UBO a link with the United States of America?",
      "hasUSPassportOrGreenCard": "Do you have USA passport or a Green card?",
      "hasSpentSubstantialTimeInUS": "Have you ever stayed for more than 90 days in the US?",
      "isUSResidentForAnyOtherReason": "Do you own real estate in the USA?",
      "errors": {
        "firstName": "First name is mandatory",
        "lastName": "Last name is mandatory",
        "nationalityIsoCode": "Nationality is mandatory",
        "residenceCountryIsoCode": "Country is mandatory",
        "workplaceCountryIsoCode": "Country of workplace is mandatory",
        "birthDate": "Date of birth is mandatory and must be valid",
        "birthDateFuture": "Date of birth can't be later than today",
        "cityOfBirth": "City of birth is mandatory",
        "countryOfBirthIsoCode": "Country of birth is mandatory",
        "addressLine1": "Address is mandatory",
        "zipCode": "Zip code is mandatory",
        "city": "City is mandatory",
        "activityId": "Activity is mandatory",
        "taxationCountryIsoCode": "Taxation country is mandatory",
        "isPoliticallyExposed": "This field is mandatory",
        "isDirector": "This field is mandatory",
        "percentageOfOwnership": "Percentage of ownership is mandatory",
        "percentageOfOwnershipInteger": "Percentage of ownership must be an integer",
        "percentageOfOwnershipRange": "Percentage of ownership must be between 0 and 100",
        "signature": "Signature is mandatory",
        "passportNumber": "Passport number is mandatory",
        "passportExpirationDate": "Passport expiration date is mandatory and must be valid",
        "passportExpirationDateOutdated": "The date must be greater than today's date",
        "isLinkedToUnitedStates": "This field is mandatory",
        "hasUSPassportOrGreenCard": "This field is mandatory",
        "hasSpentSubstantialTimeInUS": "This field is mandatory",
        "isUSResidentForAnyOtherReason": "This field is mandatory",
        "mobilePhoneNumber": "Phone number is mandatory and must be valid (i.e. +41XXXXXXXXX)",
        "email": "Email is mandatory",
        "emailValid": "Email must be valid",
        "tinNumber": "TIN number is mandatory"
      }
    },
    "companyTransaction": {
      "title": "Average company transactions per month for {displayName}",
      "subtitle": {
        "incomingTransfer": "Incoming transfers",
        "outgoingTransfer": "Outgoing transfers"
      },
      "averageAmountOfIncomingTransfer": "Volume of incoming transfers",
      "averageAmountOfIncomingTransferCurrencyIsoCode": "Currency",
      "averageAmountOfOutgoingTransfer": "Volume of outgoing transfers",
      "averageAmountOfOutgoingTransferCurrencyIsoCode": "Currency",
      "numberOfIncomingTransferPerMonth": "Number of transfers / month",
      "numberOfOutgoingTransferPerMonth": "Number of transfers / month",
      "errors": {
        "averageAmountOfIncomingTransfer": "Volume of incoming transfers is mandatory",
        "averageAmountOfIncomingTransferNumber": "Volume of incoming transfers must be a number",
        "averageAmountOfIncomingTransferCurrencyIsoCode": "Currency is mandatory",
        "averageAmountOfOutgoingTransfer": "Volume of outgoing transfers is mandatory",
        "averageAmountOfOutgoingTransferNumber": "Volume of outgoing transfers must be a number",
        "averageAmountOfOutgoingTransferCurrencyIsoCode": "Currency is mandatory",
        "numberOfIncomingTransferPerMonth": "Number of transfers is mandatory",
        "numberOfIncomingTransferPerMonthInteger": "Number of transfers must be an integer",
        "numberOfOutgoingTransferPerMonth": "Number of transfers is mandatory",
        "numberOfOutgoingTransferPerMonthInteger": "Number of transfers must be an integer"
      }
    },
    "companyCounterpartyList": {
      "transactions": "Transactions",
      "noResults": "No transactions added. Please, add all involved counterparties if necessary.",
      "deleteModal": {
        "title": "Are you sure to delete this counterparty?",
        "subtitle": "You are about to delete this counterparty: {entityName}"
      },
      "listHeaders": {
        "companyName": "Counterparty",
        "nationalityIsoCode": "Nationality",
        "funds": "Funds",
        "goods": "Goods",
        "from": "From",
        "to": "To",
        "hsCode": "HS Code",
        "operationType": "Operation type",
        "cashFlowType": "Cash flow type",
        "yearlyValuationAmount": "Annual turnover amount",
        "fundTransferFromCountryIsoCode": "Funds from",
        "fundTransferToCountryIsoCode": "Funds to",
        "commodityFromCountryIsoCode": "Goods from",
        "commodityToCountryIsoCode": "Goods to"
      }
    },
    "companyCounterpartyEdit": {
      "title": "Counterparty information",
      "companyName": "Counterparty name",
      "nationalityIsoCode": "Counterparty nationality",
      "fundTransferFromCountry": "Funds transfer from",
      "fundTransferFromSwitzerland": "CIM Banque",
      "fundTransferToCountry": "Funds transfer to",
      "fundTransferToSwitzerland": "CIM Banque",
      "commodityFromCountryIsoCode": "Goods origin",
      "commodityToCountryIsoCode": "Goods destination",
      "productType": "Goods type",
      "hsCodeChapter": "HS Code Chapter",
      "hsCode": "HS Code",
      "operationType": "Operation type",
      "cashFlowType": "Cash flow type",
      "yearlyValuationAmount": "Annual turnover amount",
      "yearlyValuationCurrencyIsoCode": "Currency",
      "bankName": "Bank name",
      "errors": {
        "companyName": "Counterparty name is mandatory",
        "nationalityIsoCode": "Nationality is mandatory",
        "fundTransferFromCountryIsoCode": "Funds origin is mandatory",
        "fundTransferToCountryIsoCode": "Funds destination is mandatory",
        "commodityFromCountryIsoCode": "Goods origin is mandatory",
        "commodityToCountryIsoCode": "Goods destination is mandatory",
        "productType": "Goods type is mandatory",
        "operationType": "Operation type is mandatory",
        "cashFlowType": "Cash flow type is mandatory",
        "yearlyValuationAmount": "Annual turnover amount is mandatory",
        "yearlyValuationAmountNumber": "Annual turnover must be a number",
        "yearlyValuationCurrencyIsoCode": "Annual turnover currency is mandatory",
        "bankName": "Bank name is mandatory"
      }
    },
    "underReview": {
      "title": "Thank you for your interest in CIM Banque.",
      "message": "Your account is under review and we will get in contact with you shortly. If you have any question about your request feel free to <a href='https://www.cimbanque.com/en/the-bank/contact-us/' target='_blank'>contact us</a>."
    },
    "refused": {
      "title": "Thank you for your interest in CIM Banque.",
      "message": "Though, we are sorry to inform you that we cannot continue with your account opening request."
    },
    "initialDeposit": {
      "title": "Your inital deposit",
      "activateAccount": "To activate your account and receive your credit cards, please make your initial deposit (Min EUR/CHF/USD 5'000) from <u>your ACTUAL PERSONAL BANK account<u> within 15 days.",
      "activateAccountCorporate": "To activate your account and receive your credit cards, please make your initial deposit (Min EUR/CHF/USD 10'000) from <u>your ACTUAL BANK account<u> within 15 days.",
      "notice": "Please note that if you do not fund your account within 15 days, it will be automatically closed."
    },
    "ibanTempo": {
      "name": "Name",
      "tempIban": "Temporary IBAN number",
      "swift": "Swift (BIC) Code",
      "bankAddress": "Bank address",
      "bank": {
        "name": "CIM BANQUE",
        "addressLine1": "RUE MERLE D'AUBIGNE 16",
        "addressLine2": "GENEVA 1211 - Switzerland",
        "swift": "CIMMCHGG"
      }
    }
  }
}
